import React, { useState } from "react";
import NavBar from "./NavBar";
import BackgroundImage from "./../images/aboutus_background.webp";
import { useNavigate } from "react-router-dom";

const AboutUsPage = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div
        className="homeHeaderContainer"
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          width: "100vw",
          height: "70vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div>
          <h1 className="homeTitleText">About Us</h1>
        </div>
      </div>
      <div className="homeBodyContainer">
        <div className="AUTitleContainer">
          <h2>Delivering compassionate home care, right to your home</h2>
          <p>
            At iCare Village, we believe that aging should be met with dignity,
            care, and a strong sense of belonging. We are a home care service
            provider delivering reliable, non-medical in-home support through a
            dedicated care team that includes care aide students, nursing
            students, and retired care professionals – all employed by iCare
            Village.
          </p>
          <p>
            Our services are designed to help older adults remain in the comfort
            of their own homes for as long as possible. Supported by our
            technology-enabled care platform, we coordinate services that
            promote independence, safety, and meaningful connection within
            familiar surroundings and local communities.
          </p>
        </div>
        <div className="AUBodyContainer">
          <div className="AUKeyPointsContainer">
            <h2>MISSION</h2>
            <h4>Connecting People with Compassionate & Reliable Home Care</h4>
            <p>
              Our mission at iCare Village is to provide compassionate,
              reliable, and affordable non-medical home care services that
              enhance quality of life for older adults. By employing and
              supporting a dedicated care team, we strive to deliver consistent,
              respectful care that helps seniors live safely, comfortably, and
              meaningfully at home.
            </p>
          </div>
          <div className="AUKeyPointsContainer">
            <h2>VISION</h2>
            <h4>Supporting Dignity and Independence at Home</h4>
            <p>
              To create a future where every senior can age at home with
              dignity, independence, and confidence – supported by compassionate
              care, thoughtful coordination, and a community that values respect
              and connection
            </p>
          </div>
          <div className="AUKeyPointsContainer">
            <h2>VALUES</h2>
            <h4>Compassion, respect, dignity and affordability</h4>
            <p>
              At iCare Village, our work is guided by compassion, respect,
              dignity, and affordability. We believe in caring for people as
              individuals, supporting independence, and building trust through
              reliable services delivered with empathy, professionalism, and
              accountability.
            </p>
          </div>
        </div>
        <div className="AUFooterContainer">
          <img
            src={require(`../images/footer-aboutus-img.png`)}
            className="AUFooterContainer-img"
          />
        </div>
      </div>
    </div>
  );
};

export default AboutUsPage;
